export default "__VITE_ASSET__C6YUG2d1__"